import { isMark } from './isMark.mjs';

function hasMark(leaf, type
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
) {
  return isMark(leaf, type) && leaf[type] != null && leaf[type] !== false;
}

export { hasMark };
